/*
 * Communications.js
 *
 * Functions for passing data between front-end and back-end system.
 */

/*
 * Constructor for communication object
 */
function Communication() {
    this.CLFR = "\r\n";
    this.headerBoundary = "----welsFormBoundary5474902110";
}

/*
 * Takes function object and passes boolean to function
 * whether a connection is active or not
 */
Communication.prototype.HasRemoteAccess = function () {
    if (navigator.onLine) {
        return true;
    }
    VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.NO_NETWORK);
    VRC.LoadingModal.hide();
    return false;
};

/*
 * Fetches JSON object from deckstate
 */
Communication.prototype.FetchDeckStateFromDB = function (p_owner, f_callback) {
    if (!this.HasRemoteAccess()) {
        return;
    }
    ClearAllContainers();
    try {
        var ver = GetVersionNumber();
        var l_source = g_data_list["source"] === undefined ? 0 : g_data_list["source"];
        $.getJSON(
            G_ROOT_ADDRESS +
                "/vessel.load_deck?h=" +
                g_data_list["hash_code"] +
                "&v=" +
                g_data_list["id"] +
                "&s=" +
                l_source +
                "&o=" +
                g_data_list["type"] +
                "&i=" +
                g_data_list["operator"] +
                "&ver=" +
                ver,
            function (p_data) {
                if (p_data == null || p_data.Error != null) {
                    VRC.ErrorHandleService.showMessage("Could not find any stored container data", G_MSG_TYPE_ERROR);
                    return;
                }
                if (p_data.WELS_container_list.length <= 0) {
                    VRC.ErrorHandleService.showMessage("No saved containers were found", G_MSG_TYPE_WARNING);
                    return;
                }
                f_callback(p_owner, p_data);
            }
        ).fail(function (p_data) {
            if (data.status === 0 && data.readyState === 0) {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.NO_RESPONSE_FROM_SERVER);
            } else {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.DEFAULT);
            }
        });
    } catch (l_err) {
        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.PARSE_ERROR_DEFAULT);
    }
};

/*
 * Creates file headers to pass on data
 */
Communication.prototype.CreateDataHeader = function (p_name, p_data, p_is_file) {
    var body = "--" + this.headerBoundary + this.CLFR + 'Content-Disposition: form-data; name="' + p_name + '"';
    if (p_is_file) {
        body += '; filename="rc_log.txt"' + this.CLFR + "Content-Type: text/plain";
    }
    body += this.CLFR + this.CLFR + p_data + this.CLFR;
    return body;
};

/*
 * Submits data as a file
 */

Communication.prototype.SubmitDataFile = function (
    p_data_content,
    p_submit_type,
    p_owner,
    onSuccess,
    onError,
    supressMessage
) {
    if (!this.HasRemoteAccess()) {
        return;
    }

    var l_url = G_ROOT_ADDRESS + "/reporting.submit_file";
    var body = this.CreateDataHeader("h", g_data_list["hash_code"], false);
    body += this.CreateDataHeader("i", g_data_list["id"], false);
    body += this.CreateDataHeader("t", g_data_list["type"], false);
    body += this.CreateDataHeader("f", p_submit_type, false);
    body += this.CreateDataHeader("o", g_data_list["operator"], false);
    body += this.CreateDataHeader("file", p_data_content, true);
    body += this.CreateDataHeader("ver", GetVersionNumber(), false);
    body += "--" + this.headerBoundary + "--" + this.CLFR;

    var com_object = this;

    $.ajax({
        contentType: "multipart/form-data; boundary=" + this.headerBoundary,
        data: body,
        type: "POST",
        cache: false,
        url: l_url,
        success: function (data, status) {
            try {
                com_object.ParseReturnData(data);

                if (onSuccess) {
                    onSuccess(p_owner, data);
                }
                if (!supressMessage) {
                    VRC.ErrorHandleService.showMessage("Data successfully submitted", G_MSG_TYPE_SUCCESS);
                }
            } catch (e) {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.PARSE_ERROR_DEFAULT);
            }
        },
        fail: function (data, status) {
            if (data.status === 401) {
                g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);
                location.reload();
            } else if (data.status === 0 && data.readyState === 0) {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.NO_RESPONSE_FROM_SERVER);
            } else if (data.responseText !== "") {
                try {
                    var error = $.parseJSON(data.responseText);
                    if (error.message) {
                        VRC.ErrorHandleService.showError(error.message);
                    }
                } catch (e) {
                    console.error(e);
                    VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.SUBMIT_ERROR_DEFAULT);
                }
            } else {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.SUBMIT_ERROR_DEFAULT);
            }

            VRC.LoadingModal.hide();
            if (onError) {
                onError(data, status);
            }
        },
    });
};

/*
 * Submits everything
 */
Communication.prototype.SubmitAllData = function (submitCode, onSuccess, onError, suppressMessage) {
    var l_extra_data = {
        version: GetVersionNumber(),
        userAgent: navigator.userAgent,
        token: g_data_list["hash_code"],
    };

    var mainVesselData = g_localsave_object.GetLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);

    var currentVoyageData = mainVesselData.current_voyage;

    var l_voyage_log_data = g_voyage_planning.CreateJSON();
    var l_bulk_data = g_localsave_object.GetLocalStorageItem(G_LS_NAMES["BULK_TANKS"]);
    var l_deck_data = g_localsave_object.GetLocalStorageItem(G_LS_NAMES["DECK_DATA"]);
    var l_container_data = g_localsave_object.GetLocalStorageItem(G_LS_NAMES["DECK_CONTAINER_DATA"]);

    if (l_voyage_log_data === null || l_bulk_data === null || l_deck_data === null || l_container_data === null) {
        VRC.ErrorHandleService.showMessage(
            "Voyage log, bulk or deck data was not valid. Please try again, or re-open browser and try again. No submission done.",
            G_MSG_TYPE_ERROR
        );
        VRC.LoadingModal.hide();
        return;
    }

    var l_data = {
        WELS_current_voyage: currentVoyageData,
        WELS_voyage_log: l_voyage_log_data,
        WELS_containers: l_container_data,
        WELS_deck_data: l_deck_data,
        WELS_bulk_data: l_bulk_data,
        WELS_fuel_log: {},
        WELS_extra_data: l_extra_data,
    };

    var l_json_data = JSON.stringify(l_data);
    this.SubmitDataFile(l_json_data, submitCode, null, onSuccess, onError, suppressMessage);
};

/*
 * Submits deck state to DB
 */
Communication.prototype.SubmitDeckStateToDB = function () {
    if (!this.HasRemoteAccess()) {
        return;
    }

    var l_container_list = g_localsave_object.GetLocalStorageItem(GL_LS_NAMES["DECK_CONTAINER_DATA"]);
    var l_deck_submission = g_localsave_object.GetLocalStorageItem(GL_LS_NAMES["DECK_DATA"]);

    var l_deck_data = { WELS_containers: l_container_list, WELS_deck: l_deck_submission };

    this.SubmitDataFile(JSON.stringify(l_deck_data), "deck");
};

/**
 * Parses data returned from a submit/fetch. This groups several functions together
 * which can instead be called separately where needed
 *
 * @param JSON_data    data to be parsed
 *
 */
Communication.prototype.ParseReturnData = function (JSON_data) {
    this.ParseValidations(JSON_data);
    this.ParseLastSubmitDate(JSON_data);
};

/**
 * Parses last submit date and submit interval.
 * Leave date empty and interval 0 if not found and save result
 *
 * @param JSON_data    data to be parsed
 *
 */
Communication.prototype.ParseLastSubmitDate = function (JSON_data) {
    try {
        var parsed_data = $.parseJSON(JSON_data);

        if (parsed_data.current_voyage) {
            parsed_data = parsed_data.current_voyage;
        }

        g_data_list.lastSubmitDate = parsed_data.lastSubmitDate || g_data_list.lastSubmitDate || "";
        g_data_list.requiredSubmitIntervalHours =
            parsed_data.requiredSubmitIntervalHours || g_data_list.requiredSubmitIntervalHours || 0;

        g_localsave_object.SetLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA, g_data_list);
    } catch (e) {
        console.error("ParseValidations", e);
    }
};

/*
 * Parses any validations returned from a submit
 */
Communication.prototype.ParseValidations = function (JSON_validations) {
    try {
        var parsed_data = $.parseJSON(JSON_validations);

        g_localsave_object.SetLocalStorageItem(G_LS_NAMES["VOYAGE_VALIDATIONS"], parsed_data.voyage_alerts || {});

        ShowVoyageValidations(g_current_page);
    } catch (e) {
        console.error("ParseValidations", e);
        $("#validation_area").html("");
        g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES["VOYAGE_VALIDATIONS"]);
    }
};

/*
 * Fetches transit containers for deck
 */
Communication.prototype.FetchTransitContainers = function () {
    var deferred = $.Deferred();
    if (!this.HasRemoteAccess()) {
        return;
    }
    try {
        $.getJSON(
            G_ROOT_ADDRESS +
                "/vessel.get_transit_containers?h=" +
                g_data_list["hash_code"] +
                "&v=" +
                g_data_list["id"] +
                "&s=" +
                g_data_list["source"] +
                "&o=" +
                g_data_list["type"] +
                "&i=" +
                g_data_list["operator"],
            function (p_data) {
                if (p_data.Error != null) {
                    VRC.ErrorHandleService.showMessage(p_data.Error, G_MSG_TYPE_ERROR);
                    return;
                }

                if (p_data.WELS_container_data === null || p_data.WELS_container_data.length <= 0) {
                    VRC.ErrorHandleService.showMessage(
                        "No transit containers found from given source.",
                        G_MSG_TYPE_WARNING
                    );
                    return;
                }

                var l_counter = PopulateTransitContainers(p_data);

                if (l_counter > 0) {
                    VRC.ErrorHandleService.showMessage(
                        "Fetched " + l_counter + " transit containers",
                        G_MSG_TYPE_SUCCESS
                    );
                } else {
                    VRC.ErrorHandleService.showMessage(
                        "No transit containers to fetch that are not already present.",
                        G_MSG_TYPE_NORMAL
                    );
                }
                deferred.resolve(p_data);
            }
        ).fail(function (p_data) {
            VRC.ErrorHandleService.showMessage(
                "There was a problem retrieving transit containers from server. Most likely a parsing issue or invalid hash. Please try to re-log or contact support",
                G_MSG_TYPE_ERROR
            );
            deferred.reject(p_data);
        });
    } catch (l_err) {
        VRC.ErrorHandleService.showMessage(
            "An error occured whilst trying to retrieve transit containers. Exception" + l_err,
            G_MSG_TYPE_ERROR
        );
        deferred.reject(l_err);
    }
    return deferred.promise();
};

/*
 * Attempts to log in and fetch main info
 */
Communication.prototype.FetchMainInfo = function (p_id, p_type, p_operator, p_password, p_username) {
    var deferred = $.Deferred();
    if (!this.HasRemoteAccess()) {
        deferred.reject({ errorMsg: "No remote access" });
    }
    try {
        var versionNumber = GetVersionNumber();

        $.ajax({
            type: "POST",
            url: G_ROOT_ADDRESS + "/vessel.get_info",
            data:
                "v=" +
                p_id +
                "&u=" +
                p_username +
                "&o=" +
                p_type +
                "&i=" +
                p_operator +
                "&p=" +
                p_password +
                "&ver=" +
                versionNumber,
            dataType: "text",
            contentType: "text/json",
            success: function (p_data_response) {
                if (p_data_response == null) {
                    SetLoginInformation("Could not log in", "Could not log in");
                    deferred.reject({
                        errorMsg:
                            "No user data found for id: " + p_id + ", type:" + p_type + ", operator: " + p_operator,
                    });
                } else if (p_data_response.indexOf("Invalid or missing password") > 1) {
                    SetLoginInformation("Could not log in", "Could not log in");
                    g_dataIsReady = false;
                    deferred.reject({ errorMsg: p_data_response });
                } else {
                    try {
                        var p_data = jQuery.parseJSON(p_data_response);
                        var currentVoyage;
                        g_data_list = p_data[G_LS_NAMES["MAIN_VESSEL_DATA"]];

                        g_data_list["operator"] = p_operator;

                        SetLoginInformation(g_data_list["name"], p_operator);

                        g_data_list["deck_scale_value"] = G_DECK_SCALES["VESSEL"];

                        if (g_data_list.current_voyage) {
                            currentVoyage = JSON.parse(g_data_list.current_voyage);
                            g_data_list.lastSubmitDate = currentVoyage.lastSubmitDate || "";
                            g_data_list.requiredSubmitIntervalHours = currentVoyage.requiredSubmitIntervalHours || 0;
                            g_data_list.showDepartureWarnings = currentVoyage.showDepartureWarnings || "no";
                            g_data_list.enableVoyageDpMode = currentVoyage.enableVoyageDpMode || "no";
                        }

                        g_localsave_object.SetLocalStorageItem(G_LS_NAMES["MAIN_VESSEL_DATA"], g_data_list);

                        g_localsave_object.SetLocalStorageItem(
                            G_LS_NAMES["DECK_DATA"],
                            p_data[G_LS_NAMES["DECK_DATA"]]
                        );
                        g_localsave_object.SetLocalStorageItem(G_LS_NAMES["DECK_CONTAINER_DATA"], g_container_list); // resets container list

                        var fetchingBulkTanks = VRC.BulkState.fetchBulkTanks();

                        fetchingBulkTanks.done(function () {
                            VRC.BulkState.init();
                            deferred.resolve();
                        });
                    } catch (l_err) {
                        deferred.reject({
                            errorMsg: "An error occured whilst trying to retrieve user data. Exception" + l_err,
                        });
                    }
                }
            },
            error: function (xhr, responseType, p_data) {
                var errorObj = {
                    errorMsg: "",
                };
                if (p_data.indexOf("User exceeded maxmimum number") > 1) {
                    errorObj.errorMsg = p_data;
                } else {
                    errorObj.errorMsg =
                        "There was a problem retrieving main data from server. Most likely a parsing issue. Please try to re-log or contact support" +
                        p_data;
                }
                deferred.reject(errorObj);
            },
        });
    } catch (l_err) {
        deferred.reject({ errorMsg: "An error occured whilst trying to retrieve user data. Exception" + l_err });
    }
    return deferred.promise();
};

/*
 * Writes return statement of the specific type based on returned data from server
 */
Communication.prototype.ProcessReturnedSavedStatement = function (p_return_data) {
    if (p_return_data !== undefined && p_return_data != null) {
        if (p_return_data.length > 0) {
            try {
                var l_data = JSON.parse(p_return_data);
                VRC.ErrorHandleService.showMessage(l_data[0].msg, l_data[0].status);
            } catch (err) {
                VRC.ErrorHandleService.showMessage(
                    "Data sent to server. Additional info: " + p_return_data,
                    G_MSG_TYPE_NORMAL
                );
            }
        } else {
            VRC.ErrorHandleService.showMessage("Data sent to server.", G_MSG_TYPE_SUCCESS);
        }
    } else {
        VRC.ErrorHandleService.showMessage("Data sent to server", G_MSG_TYPE_SUCCESS);
    }
};

Communication.prototype.FetchDataFromServer = function (p_owner, onSuccess, p_fetch_type, p_params, onError) {
    if (!this.HasRemoteAccess()) {
        return;
    }
    try {
        if (p_params) {
            p_params = JSON.stringify(p_params);
        } else {
            p_params = GetVersionNumber();
        }

        var l_params =
            "h=" +
            g_data_list["hash_code"] +
            "&i=" +
            g_data_list["id"] +
            "&t=" +
            g_data_list["type"] +
            "&f=" +
            p_fetch_type;
        l_params += "&o=" + g_data_list["operator"] + "&d=" + p_params;

        $.getJSON(G_ROOT_ADDRESS + "/reporting.fetch_data?" + l_params, function (p_data) {
            // we want to save current voyage data, which could be coming from either current_voyage or voyage.
            if (p_data.current_voyage || (p_data.voyage && p_data.voyage.lastSubmitDate)) {
                var currentVoyage = p_data.current_voyage || p_data.voyage;
                g_data_list.lastSubmitDate = currentVoyage.lastSubmitDate || "";
                g_data_list.requiredSubmitIntervalHours = currentVoyage.requiredSubmitIntervalHours || 0;
                g_data_list.showDepartureWarnings = currentVoyage.showDepartureWarnings || "no";
                g_data_list.enableVoyageDpMode = currentVoyage.enableVoyageDpMode || "no";
                g_data_list.current_voyage = currentVoyage;
                g_localsave_object.SetLocalStorageItem(G_LS_NAMES["MAIN_VESSEL_DATA"], g_data_list);
            }
            onSuccess(p_owner, p_data);
        }).fail(function (response) {
            if (response.status === 401) {
                g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);
                location.reload();
            } else if (response.status === 0 && response.readyState === 0) {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.NO_RESPONSE_FROM_SERVER);
            } else if (response.responseText !== "") {
                try {
                    var error = $.parseJSON(response.responseText);
                    if (error.message) {
                        VRC.ErrorHandleService.showError(error.message);
                    }
                } catch (e) {
                    console.error(e);
                    VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.FETCH_ERROR_DEFAULT);
                }
            } else {
                VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.FETCH_ERROR_DEFAULT);
            }

            if (onError) {
                onError(response);
            }
        });
    } catch (l_err) {
        VRC.ErrorHandleService.showMessage(
            "An error occured whilst trying to fetch data from server. Exception " + l_err,
            G_MSG_TYPE_ERROR
        );
    }
};

/*
 * Fetches data from DB as HTML and lets a callback function handle the result
 */
Communication.prototype.FetchHTMLFromServer = function (p_owner, f_callback, p_fetch_type, p_params) {
    if (!this.HasRemoteAccess()) {
        return;
    }
    try {
        var l_params =
            "h=" +
            g_data_list["hash_code"] +
            "&i=" +
            g_data_list["id"] +
            "&t=" +
            g_data_list["type"] +
            "&f=" +
            p_fetch_type;
        l_params += "&o=" + g_data_list["operator"] + "&d=" + p_params;

        $.get(G_ROOT_ADDRESS + "/reporting.fetch_data?" + l_params, function (p_data) {
            f_callback(p_owner, p_data);
        }).fail(function (response) {
            if (response.status === 401) {
                g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);
                location.reload();
            }
            VRC.ErrorHandleService.showMessage(
                "FetchHTMLFromServer: There was a problem fetching data from server. Most likely a parsing issue or invalid hash. Please try to re-log or contact support. Debug: " +
                    response,
                G_MSG_TYPE_ERROR
            );
        });
    } catch (l_err) {
        VRC.ErrorHandleService.showMessage(
            "An error occured whilst trying to fetch data from server. Exception" + l_err,
            G_MSG_TYPE_ERROR
        );
    }
};

/*
 * Fetches master data from DB and lets a callback function handle the result
 */
Communication.prototype.FetchMasterData = function (p_owner, onSuccess, onError) {
    try {
        var l_type = localStorage["login_user_param"];
        var l_operator = localStorage["login_operator_param"];

        if (l_type === undefined || l_type == null || l_type == "null") {
            l_type = g_data_list["type"];
        }

        if (l_operator === undefined || l_operator == null || l_operator == "null") {
            l_operator = g_data_list["operator"];
        }

        if (
            l_operator === undefined ||
            l_operator == null ||
            l_operator == "null" ||
            l_type === undefined ||
            l_type == null ||
            l_type == "null"
        ) {
            VRC.ErrorHandleService.showMessage(
                "FetchMasterData: There was a problem fetching master data from server. Could not find the type or operator name. Please try to re-log or contact support",
                G_MSG_TYPE_ERROR
            );
            return;
        }

        var l_params = "h=00000000&i=99" + "&t=" + l_type + "&o=" + l_operator;
        $.getJSON(G_ROOT_ADDRESS + "/reporting.get_master_data?" + l_params, function (p_data) {
            onSuccess(p_owner, p_data);
        }).fail(function (response) {
            onError =
                onError ||
                function (response) {
                    response = response || {};
                    if (response.status === 401) {
                        g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);
                        location.reload();
                    } else if (response.status === 0 && response.readyState === 0) {
                        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.NO_RESPONSE_FROM_SERVER);
                    } else if (response.responseText !== "") {
                        try {
                            var error = $.parseJSON(response.responseText);
                            if (error.message) {
                                VRC.ErrorHandleService.showError(error.message);
                            }
                        } catch (e) {
                            console.error(e);
                            VRC.ErrorHandleService.showError(
                                "An error occured whilst trying to fetch master data from server."
                            );
                        }
                    } else {
                        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.SUBMIT_ERROR_DEFAULT);
                    }

                    console.error(response.responseText);
                };
            onError(response);
        });
    } catch (l_err) {
        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.PARSE_ERROR_DEFAULT);
    }
};

Communication.prototype.FetchMasterData2 = function (p_owner, onSuccess, onError) {
    try {
        var l_type = localStorage["login_user_param"];
        var l_operator = localStorage["login_operator_param"];
        var vessel_data = JSON.parse(localStorage["WELS_vessel_data"]);
        var l_vessel_id = vessel_data.id;
        var l_vessel_hash = vessel_data.hash_code;

        if (l_type === undefined || l_type == null || l_type == "null") {
            l_type = g_data_list["type"];
        }

        if (l_operator === undefined || l_operator == null || l_operator == "null") {
            l_operator = g_data_list["operator"];
        }

        if (
            l_operator === undefined ||
            l_operator == null ||
            l_operator == "null" ||
            l_type === undefined ||
            l_type == null ||
            l_type == "null"
        ) {
            VRC.ErrorHandleService.showMessage(
                "FetchMasterData: There was a problem fetching master data from server. Could not find the type or operator name. Please try to re-log or contact support",
                G_MSG_TYPE_ERROR
            );
            return;
        }

        if (l_vessel_id == undefined) {
            l_vessel_id = g_data_list.id;
        }

        if (l_vessel_hash == undefined) {
            l_vessel_hash = g_data_list.hash_code;
        }

        var l_params = "h=" + l_vessel_hash + "&i=" + l_vessel_id + "&t=" + l_type + "&o=" + l_operator;
        $.getJSON(G_ROOT_ADDRESS + "/reporting.get_master_data2?" + l_params, function (p_data) {
            onSuccess(p_owner, p_data);
        }).fail(function (response) {
            onError =
                onError ||
                function (response) {
                    response = response || {};
                    if (response.status === 401) {
                        g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);
                        location.reload();
                    } else if (response.status === 0 && response.readyState === 0) {
                        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.NO_RESPONSE_FROM_SERVER);
                    } else if (response.responseText !== "") {
                        try {
                            var error = $.parseJSON(response.responseText);
                            if (error.message) {
                                VRC.ErrorHandleService.showError(error.message);
                            }
                        } catch (e) {
                            console.error(e);
                            VRC.ErrorHandleService.showError(
                                "An error occured whilst trying to fetch master data from server."
                            );
                        }
                    } else {
                        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.SUBMIT_ERROR_DEFAULT);
                    }

                    console.error(response.responseText);
                };
            onError(response);
        });
    } catch (l_err) {
        VRC.ErrorHandleService.showDefaultError(VRC.ErrorHandleService.errors.PARSE_ERROR_DEFAULT);
    }
};

/**
 * Fetches user info from database. Clears previously saved deck and container data
 * and sets user and deck data.
 * Also saves this to local storage
 */
function FetchMainInfo(p_id, p_type, p_operator, p_password, p_username) {
    // Clear everything first
    ClearAllContainers();
    RemoveDecks();

    return g_remote_object.FetchMainInfo(p_id, p_type, p_operator, p_password, p_username);
}
